import React from "react";
import { Button } from "@src/components";
import { INVALID_VALUE } from "@src/constants/InvalidValue";
import { CommunityPostListItemDto } from "./service/types";

const cellStyle: React.CSSProperties = {
    width: "100%",
    minWidth: "80px",
    textAlign: "center",
};

export const getColumns = (
    onViewDetail: (post: CommunityPostListItemDto) => void,
    onDelete: (post: CommunityPostListItemDto) => void,
) => [
    {
        Header: "번호",
        accessor: "postNo",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "50px" }}>{value ?? INVALID_VALUE}</div>
        ),
    },
    {
        Header: "글 제목",
        accessor: "title",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "160px" }}>{value ? value : INVALID_VALUE}</div>
        ),
    },
    {
        Header: "글 내용",
        accessor: "content",
        Cell: ({ cell: { value } }: any) => (
            <div
                style={{
                    ...cellStyle,
                    minWidth: "200px",
                    maxWidth: "300px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "올린 물건",
        accessor: "postedItems",
        Cell: ({ cell: { value } }: any) => {
            const items: string[] = value ?? [];
            if (items.length === 0) {
                return <div style={cellStyle}>{INVALID_VALUE}</div>;
            }
            return (
                <div
                    style={{
                        ...cellStyle,
                        minWidth: "160px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                    }}
                >
                    {items.map((item, index) => (
                        <span key={`${item}-${index}`}>{item}</span>
                    ))}
                </div>
            );
        },
    },
    {
        Header: "유저 이름",
        accessor: "writer",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "80px" }}>{value ? value : INVALID_VALUE}</div>
        ),
    },
    {
        Header: "등록일",
        accessor: "createdAt",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "100px" }}>{value ? value.slice(0, 10) : INVALID_VALUE}</div>
        ),
    },
    {
        Header: "상세 조회",
        accessor: "viewMore",
        Cell: ({ row }: any) => {
            const post: CommunityPostListItemDto = row?.original;
            return (
                <div
                    style={{
                        ...cellStyle,
                        minWidth: "90px",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Button color="purple" size="small" label="상세 조회" handleClick={() => onViewDetail(post)} />
                </div>
            );
        },
    },
    {
        Header: "삭제",
        accessor: "delete",
        Cell: ({ row }: any) => {
            const post: CommunityPostListItemDto = row?.original;
            return (
                <div style={{ ...cellStyle, minWidth: "70px", display: "flex", justifyContent: "center" }}>
                    <Button color="purple" size="small" label="삭제" handleClick={() => onDelete(post)} />
                </div>
            );
        },
    },
];
